import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FormOutlined, ProfileOutlined, EyeOutlined, InsertRowBelowOutlined } from '@ant-design/icons';
import { Table, Row, Col, Breadcrumb, Typography, Tooltip } from 'antd';
import { intialPaginationState, showingPageTotalRange, unexpectedError, filter } from '../../common_functions';
const Collections = props => {
  let {
    tabs_permissions: { negatives: { view: viewNeg, create: createNeg } = {}, prints: { view: viewPrint, create: createPrint } = {} } = {},
  } = props;
  if (props.roleType == 'admin') {
    viewNeg = true;
    createNeg = true;
    viewPrint = true;
    createPrint = true;
  }
  const [collections, setCollections] = useState([]);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);
  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: 'Collection Name',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      ...filter('name'),
    },
    {
      title: 'Collection Location',
      dataIndex: 'address',
      key: 'address',
      sorter: true,
      ...filter('address'),
    },
    {
      title: 'Collection Contact Name',
      dataIndex: 'contact_name',
      key: 'contact_name',
      sorter: true,
      ...filter('contact_name'),
    },
    {
      title: 'Associated To',
      dataIndex: 'associated_to',
      key: 'associated_to',
      render: text => <span style={{ textTransform: 'capitalize' }}>{text}</span>,
      sorter: true,
      ...filter('associated_to'),
    },

    {
      title: 'Actions',
      key: 'action',
      render: (text, record) => {
        const isAssociatedToNegative = record?.associated_to === 'negative' || record?.associated_to === 'both';
        const isAssociatedToPrint = record?.associated_to === 'print' || record?.associated_to === 'both';

        return (
          <span>
            <div className="actionbtngroup">
              <Link to={'/collections/edit/' + record.id}>
                <Tooltip placement="top" title="Edit">
                  <button className="edit-btn">
                    <FormOutlined />
                  </button>
                </Tooltip>
              </Link>
              {!!createNeg && isAssociatedToNegative && (
                <Link to={'/negatives/negative-objects/collection/' + record.id} disabled={true}>
                  <Tooltip placement="top" title="Create negative object">
                    <button className="edit-btn">
                      <ProfileOutlined />
                    </button>
                  </Tooltip>
                </Link>
              )}
              {!!createPrint && isAssociatedToPrint && (
                <Link to={'/print-objects/collection/' + record.id}>
                  <Tooltip placement="top" title="Create print object">
                    <button className="edit-btn">
                      <InsertRowBelowOutlined />
                    </button>
                  </Tooltip>
                </Link>
              )}
              {!!viewNeg && isAssociatedToNegative && (
                <Link to={'/negatives/negative-objects/list/' + record.id}>
                  <Tooltip placement="top" title="Negatives">
                    <button className="edit-btn">
                      <EyeOutlined />
                    </button>
                  </Tooltip>
                </Link>
              )}
              {!!viewPrint && isAssociatedToPrint && (
                <Link to={'/print-objects/list/' + record.id}>
                  <Tooltip placement="top" title="Prints">
                    <button className="edit-btn">
                      <EyeOutlined />
                    </button>
                  </Tooltip>
                </Link>
              )}

              {props.deleteRecord(props, record.id, 'collections', 'collection and its associated records?', collections, setCollections)}
            </div>
          </span>
        );
      },
    },
  ];
  //Get collection data
  useEffect(() => {
    (async () => {
    await getColData(pagination);
  })();
  }, []);

  const getColData = async (pagination, filters = {}, sorter = '') => {
    try {
      setLoading(true);
      if (props.roleType !== 'admin') {
        filters['user_permission'] = {
          _and: [{ user: { _eq: props.user.id } }, { view: { _eq: true } }],
        };
      }
      const response = await props.getItems('collections', {
        fields: ['id', 'name', 'address', 'contact_name', 'associated_to', 'user_permission.*'],
        sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
        filters: filters,
        offset: pagination.pageSize * (pagination.current - 1),
        limit: pagination.pageSize,
        meta: 'filter_count',
      });
      pagination.total = response.meta.filter_count;
      setPagination(pagination);
      setCollections(response.data);
    } catch (error) {
      console.error(error);
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = async (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorter(sorter);
    setLoading(true);
    let filtersitems = {};
    for (let key in filters) {
      if (filters.hasOwnProperty(key)) {
        let val = filters[key];
        val && (key == 'id' ? (filtersitems[key] = { _eq: val[0] }) : (filtersitems[key] = { _icontains: val[0] }));
      }
    }
    await getColData(pagination, filtersitems, sorter);
  };
  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Collections" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                View Collection
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end">
              {props.createButton(props.roleType, props.tabs_permissions.collections, '/collections/new', 'Create Collection')}
            </Col>
          </Row>
          <hr />
          <div className="artist-list">
            <Table
              scroll={{ x: 'max-content' }}
              columns={columns}
              bordered
              rowKey={record => record.id}
              dataSource={collections}
              pagination={{ ...pagination, ...showingPageTotalRange }}
              loading={loading}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default Collections;
